import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';

interface DesbloqueioConfiancaConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  colors: { primaryColor: string };
}

export function DesbloqueioConfiancaConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting,
  colors,
}: DesbloqueioConfiancaConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={!isSubmitting}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Desbloqueio de Confiança</ModalHeader>
        <ModalCloseButton isDisabled={isSubmitting} />
        <ModalBody>
          <Text>Deseja realmente solicitar o desbloqueio de confiança?</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            variant="ghost"
            backgroundColor="transparent"
            color={colors.primaryColor}
            onClick={onClose}
            marginRight={2}
            isDisabled={isSubmitting}
          >
            Cancelar
          </Button>
          <Button type="button" onClick={onConfirm} isLoading={isSubmitting}>
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
